export const getUser = (state, id) => state.entities.users[id];

const userSelectors = {
    getUser,
};

export default userSelectors;
